const SET_THEME = '[theme]set';
const GET_THEME = '[theme]get';

export {SET_THEME, GET_THEME}
